import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';
import {useAnalytics} from 'contexts/Analytics';

import './contacts.scss';

const Contacts = () => {
  const {handleEvent} = useAnalytics();

  return (
    <section className="contacts">
      <Container extraClassName="contacts__wrapper">
        <div className="contacts__wrapper_left">
          <Title
            extraClassName="contacts__title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
          >
            Остались вопросы?
          </Title>
        </div>

        <div className="contacts__wrapper_right">
          <p className="contacts__subscript">
            Напишите нам. Мы&nbsp;ответим в&nbsp;течение часа в&nbsp;Telegram
            и&nbsp;Intercom
          </p>

          <div className="contacts__buttons">
            <a
              className="contacts__button contacts__button_telegram"
              href="https://t.me/handsrubot"
              onClickCapture={handleEvent('telegram_click')}
            >
              telegram
            </a>

            {window.Intercom ? (
              <button
                className="contacts__button contacts__button_intercom"
                onClick={() => {
                  window.Intercom('show');
                }}
                onClickCapture={handleEvent('intercom_click')}
              >
                intercom
              </button>
            ) : (
              <a
                className="contacts__button contacts__button_intercom"
                href="https://intercom.help/ruki/ru/"
                onClickCapture={handleEvent('intercom_click')}
              >
                intercom
              </a>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Contacts;
